import { useState } from '#app';

/**
 * Shared state composable for tracking the active/triggering focus element.
 * Allows manually setting the element or falling back to the default tracking.
 */
export const useActiveFocus = () => {
  const activeEl = useState<HTMLElement | null>('ask-ai-active-element', () => null);

  const setActiveElement = (el: HTMLElement | null) => {
    activeEl.value = el;
  };

  return {
    activeEl,
    setActiveElement,
  };
};
